import React, { useState } from "react";
import { useParams } from "react-router";
import clsx from "clsx";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { CopyTextOrLinkToClipboard, getSessionId } from "../../../../../shared/utility";
import { COPY_SECTIONS } from "../../../../../constants/InviteConstants";
import { TOAST_MESSAGE } from "../../../../../constants/ToastMsgLocalize";
import { GLOBAL_MEETING_DATA } from "../../../../../constants/PublicVariables";

const CopyTab = ({ inviteUrl, isForGuest, localisedValues, handleCloseModal, isDoneBtnVisible }) => {
    const params = useParams();
    const sessionId = getSessionId(params?.sessionId);
    const { joinMeetingSmsTemplate } = useSelector((state) => state.inviteParticipant);
    const [copiedFrom, setCopiedFrom] = useState("");

    const handleCopyLink = (from) => {
        if (from === COPY_SECTIONS.COPY_INVITATION) {
            const message = `${joinMeetingSmsTemplate}\r\n\r\n${localisedValues["reference"]}:${GLOBAL_MEETING_DATA.sessionId}\r\n\r\n${localisedValues["join_the_session"]}\r\n${inviteUrl}`;
            CopyTextOrLinkToClipboard(message, localisedValues[TOAST_MESSAGE.SESSION_INVITATION_COPIED]);
        } else if (from === COPY_SECTIONS.COPY_SESSION_CODE) {
            CopyTextOrLinkToClipboard(sessionId, localisedValues[TOAST_MESSAGE.SESSION_CODE_COPY]);
        } else if (from === COPY_SECTIONS.COPY_SESSION_LINK) {
            const msg = isForGuest ? localisedValues[TOAST_MESSAGE.GUEST_URL_COPY] : localisedValues[TOAST_MESSAGE.OBSERVER_URL_COPIED];
            CopyTextOrLinkToClipboard(inviteUrl, msg);
        }

        setCopiedFrom(from);

        setTimeout(() => {
            setCopiedFrom("");
        }, 7000);
    };

    return (
        <div
            className='tab-pane active'
            id='invite-copy-link'
            role='tabpanel'
            aria-labelledby='invite-copy-link-tab'
            data-testid='invite-copy-link-tab'
        >
            <div className='invite-participant'>
                <div className='invite-participant-box copy-link-out-box'>
                    <div className='invite-title-mobile'>
                        <h3>{localisedValues.other}</h3>
                    </div>
                    <div className='invite-title-desktop'>
                        <h3>{localisedValues.share_invitation_with_others}</h3>
                    </div>
                    <div className='invite-participant-form other-invitation-form default-custom-scroll-thin'>
                        <div
                            className={clsx(
                                "other-invitation-box custom-tooltip top-tooltip center-tooltip tooltip-auto-width",
                                copiedFrom === COPY_SECTIONS.COPY_INVITATION && "copied"
                            )}
                            data-testid='copyInvitation'
                            onClick={() => handleCopyLink(COPY_SECTIONS.COPY_INVITATION)}
                            onKeyDown={() => {}}
                        >
                            <div className='custom-tooltip-content text-nowrap text-center'>
                                <div className='custom-tooltip-in'>
                                    <p>{localisedValues.copied}</p>
                                </div>
                            </div>
                            <div className='other-invitation-icon'>
                                <span className='for-icon icon-session-history'></span>
                            </div>
                            <div className='other-invitation-text'>
                                <h4>{localisedValues.copy_invitation}</h4>
                                <p>{localisedValues.copy_invitation_desc}</p>
                            </div>
                        </div>
                        <div
                            className={clsx(
                                "other-invitation-box custom-tooltip top-tooltip center-tooltip tooltip-auto-width",
                                copiedFrom === COPY_SECTIONS.COPY_SESSION_CODE && "copied"
                            )}
                            data-testid='copySessionCode'
                            onClick={() => handleCopyLink(COPY_SECTIONS.COPY_SESSION_CODE)}
                            onKeyDown={() => {}}
                        >
                            <div className='custom-tooltip-content text-nowrap text-center'>
                                <div className='custom-tooltip-in'>
                                    <p data-testid='copyToolTip'>{localisedValues.copied}</p>
                                </div>
                            </div>
                            <div className='other-invitation-icon'>
                                <span className='for-icon icon-session-history'></span>
                            </div>
                            <div className='other-invitation-text'>
                                <h4>{localisedValues.copy_session_code}</h4>
                                <p>
                                    <span className={clsx(copiedFrom === COPY_SECTIONS.COPY_SESSION_CODE && "selected-element")}>{sessionId}</span>
                                </p>
                            </div>
                        </div>
                        <div
                            className={clsx(
                                "other-invitation-box custom-tooltip top-tooltip center-tooltip tooltip-auto-width",
                                copiedFrom === COPY_SECTIONS.COPY_SESSION_LINK && "copied"
                            )}
                            data-testid='copySessionLink'
                            onClick={() => handleCopyLink(COPY_SECTIONS.COPY_SESSION_LINK)}
                            onKeyDown={() => {}}
                        >
                            <div className='custom-tooltip-content text-nowrap text-center'>
                                <div className='custom-tooltip-in'>
                                    <p>{localisedValues.copied}</p>
                                </div>
                            </div>
                            <div className='other-invitation-icon'>
                                <span className='for-icon icon-link'></span>
                            </div>
                            <div className='other-invitation-text'>
                                <h4>{localisedValues.copy_link_to_share}</h4>
                                <p>
                                    <span className={clsx(copiedFrom === COPY_SECTIONS.COPY_SESSION_LINK && "selected-element")}>{inviteUrl}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='invite-participant-footer'>
                    <div className='button-inline more-space d-flex justify-content-end align-items-center'>
                        {isDoneBtnVisible && (
                            <div className='button' data-testid='doneBtn'>
                                <button type='button' className='btn btn-link default-btn-link' onClick={handleCloseModal}>
                                    {localisedValues.done}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

CopyTab.propTypes = {
    inviteUrl: PropTypes.string,
    isForGuest: PropTypes.bool,
    localisedValues: PropTypes.object,
    handleCloseModal: PropTypes.func,
    isDoneBtnVisible: PropTypes.bool,
};

export default CopyTab;
